import "@fortawesome/fontawesome-free/css/all.css";
import { Grid } from "@mui/material";
import { ArrowBack } from "@mui/icons-material";
import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { findMasseursNearestFreeDateEvent, resetSearchResults } from "../../features/reservationSlice";
import EnhancedIconButton from "../enhanced/EnhancedIconButton";
import { useSelector } from "react-redux";
import {fetchMasseurs, removeMasseurList} from "../../features/listsSlice";
import EnhancedSelect from "../enhanced/EnhancedSelect";

const CalendarMasseurFreeDateSearchForm = (props) => {
  const dispatch = useDispatch();

  const { headerToolbarConf, headerToolbar, setHeaderToolbar, setEventView, eventViewConstants, isAgendaView } = props;
  const masseurList = useSelector((state) => state.lists.masseurList);
  const [formState, setFormState] = useState({});

  useEffect(() => {
    formState.masseurId && dispatch(findMasseursNearestFreeDateEvent(formState.masseurId));
  }, [dispatch, formState.masseurId]);

    useEffect(() => {
        if (masseurList.length === 0) {
            dispatch(fetchMasseurs());
        }
    }, [masseurList, dispatch]);

  const handleBackBtn = () => {
    setHeaderToolbar(headerToolbarConf);
    setEventView(eventViewConstants.CALENDAR_VIEW);
    dispatch(resetSearchResults());
    dispatch(removeMasseurList())
    formState.masseurId = null;
  };

  function handleChange(event) {
      event.persist();
      setFormState((formState) => ({
          ...formState,
          [event.target.name]: event.target.value
      }));
  }

  function getSearchFormStyle(headerToolbar)
  {
    if (headerToolbar === false) {
      return styles.searchInput;
    }

    var display = styles.none;
    if (isAgendaView) {
      display = 'inline';
    }

    return  {display: display}
  }

  return (
    <Grid sx={getSearchFormStyle} container spacing={1}>
      <Grid item xs={6}>
        <EnhancedIconButton ariaLabel="back icon" tooltip="Zpět" Icon={ArrowBack} onClick={handleBackBtn} />
      </Grid>
      <Grid item xs={12}>
          <EnhancedSelect
              name="masseurId"
              value={formState.masseurId}
              label="Masér"
              list={masseurList}
              onChange={handleChange}
              itemName="fullName"
          />
      </Grid>
    </Grid>
  );
};

const styles = {
  root: {
    fontFamily: "Roboto, Helvetica, Arial, sans-serif !important"
  },
  none: {
    display: "none"
  },
  searchInput: { marginBottom: "1em" }
};

export default CalendarMasseurFreeDateSearchForm;
